import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/layouts/default.vue").then(m => m.default || m)),
  "site-default": defineAsyncComponent(() => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/api/vendors/gsmaterials/app/layouts/site/default.vue").then(m => m.default || m))
}